// "About you" options for the start form. The API serves the live list (GET /v1/config,
// apps/api/src/services/intake.ts); this copy is only the fallback if that call fails.

export interface IntakeOption {
  value: string;
  label: string;
}
export interface IntakeOptions {
  occupations: IntakeOption[];
  ageBrackets: IntakeOption[];
  genders: IntakeOption[];
}

export const FALLBACK_INTAKE: IntakeOptions = {
  occupations: [
    { value: "nine_to_five", label: "I work a 9-5 job" },
    { value: "career_leader", label: "I have a career and consider myself a leader" },
    { value: "business_owner", label: "I own/run a business" },
    { value: "unemployed", label: "I am unemployed" },
    { value: "student", label: "I am a student" },
    { value: "retired", label: "I am retired" },
    { value: "other", label: "Other" },
  ],
  ageBrackets: [
    { value: "18_24", label: "18–24" },
    { value: "25_34", label: "25–34" },
    { value: "35_44", label: "35–44" },
    { value: "45_54", label: "45–54" },
    { value: "55_64", label: "55–64" },
    { value: "65_plus", label: "65 or older" },
    { value: "prefer_not", label: "Prefer not to say" },
  ],
  genders: [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "prefer_not", label: "Prefer not to say" },
  ],
};
